module.exports = __webpack_public_path__ + "img/icon_unselected_jilong.99751900.png";